<template>
    <sys-register-base 
        :loading="loading" 
        :model.sync="model" 
        :title="title" 
        :icon="icon" 
        v-bind:show.sync="dialog"
        maxWidth="100%"
        :showRequiredFields="false"
        :showButton="false"
    >
        <template v-slot:form>
            <v-container fluid>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-progress-linear
                                v-if="loading"
                                indeterminate
                                color="cyan lighten-4"
                            />
                            <v-data-table
                                :items="items"
                                :headers="headers.filter(h => h.visible)"
                                sort-by="calories"
                                class="elevation-1"
                                item-key="index"
                                :hide-default-footer="true"
                                :items-per-page="-1"
                                fixed-header
                                height="400"
                            >

                                <!-- <template v-slot:item.actions="{ item, index }">

                                    <emc-button-icon
                                        :loading="index == indexItem && loadingDelete"
                                        icon="mdi-calendar-minus"
                                         color="primary"
                                        @click="showDeleteItem(item, index)"
                                        :disabled="disabledActions || item.occurrence_type_id != null"
                                        text='Cadastrar Ocorrência'
                                        iconSmall
                                    />

                                </template>
                             -->
                            </v-data-table>
                        </v-col>
                    </v-row>
            </v-container>

            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>

        </template>

       
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: "SysOccurrenceSheetTeacherViewRegister",
    data: (vm) => ({
        loading: false,
        dialog: false,
        error: false,
        items: [],
        errors: {},
        message: '',
        headers: [
            { text: 'Data',         value: 'date',                  align: 'start', sortable: false, visible: true, width: '12%' },
            { text: 'Descrição',    value: 'description',           align: 'start', sortable: false, visible: true, width: '30%'  },
            { text: 'Entrada 1',     value: 'check_in_1',           align: 'start', sortable: false, visible: true, width: '10%'  },
            { text: 'Saída 1',       value: 'check_out_1',             align: 'start', sortable: false, visible: true, width: '10%'  },
            { text: 'Entrada 2',     value: 'check_in_2',           align: 'start', sortable: false, visible: true, width: '10%'  },
            { text: 'Saída 2',       value: 'check_out_2',             align: 'start', sortable: false, visible: true, width: '10%'  },
            { text: 'Entrada 3',     value: 'check_in_3',           align: 'start', sortable: false, visible: true, width: '10%'  },
            { text: 'Saída 3',       value: 'check_out_3',             align: 'start', sortable: false, visible: true, width: '10%'  },
            { text: 'Ocorrência',   value: 'type',                  align: 'center',sortable: false, visible: true, width: '10%'  },
            { text: 'Status',       value: 'occurrence_status_id',  align: 'center',sortable: false, visible: false, width: '10%'  },
            { text: '',             value: 'actions',               align: 'center',sortable: false, visible: true, width: '10%' },
        ],
    }),
    created(){

    },

    computed: {
      ...mapState('auth', ['acesso']),

    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;

            if(show_new){
                
                this.getData();

            }
        },
        
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-book-open-page-variant"
        },
        title: {
            type: String,
            default: "Registros de Marcações"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        },

    },
    methods:{
        ...mapActions('timeSheet', ['ActionIndexOccurrenceSheetItems']),

        getData(){

                this.loading = true;
                this.items = [];


                this.ActionIndexOccurrenceSheetItems(payload)
                    .then((res) => {
                        this.items = res.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });

        },

    }
}
</script>